/* eslint-disable import/prefer-default-export */
import { task as taskCore } from '@breezeway/brzw-react-core';

import common from '@common';
import * as taskActions from './actions';

const {
  utils: {
    taskHelper: {
      TASK_ASSIGNMENT_STATUS: { ACCEPTED, DECLINED },
    },
  },
} = common;

/**
 * @param {Number} taskUpdateAssignmentId
 * @param {Object} data
 */
export const updateAssignmentTask = (taskUpdateAssignmentId, data) => dispatch => {
  dispatch(taskActions.setTaskUpdateFetchingFlag(true));
  dispatch(taskActions.setLastTaskId(taskUpdateAssignmentId));

  dispatch(
    taskCore.actions.updateTaskAssignmentOnList(
      taskUpdateAssignmentId,
      data,
      dispatch.bind(this, taskActions.setTaskUpdateFetchingFlag(false)),
      dispatch.bind(this, taskActions.setTaskUpdateFetchingFlag(false)),
    ),
  );
};

/**
 * @param {Number} taskOfferUpdateAssignmentId
 * @param {Object} data
 */
export const updateAssignmentTaskOffer = (taskOfferUpdateAssignmentId, data) => dispatch => {
  dispatch(taskActions.setTaskUpdateFetchingFlag(true));
  dispatch(taskActions.setLastTaskId(taskOfferUpdateAssignmentId));

  dispatch(
    taskCore.actions.updateAssignmentTaskOffer(
      taskOfferUpdateAssignmentId,
      data,
      dispatch.bind(this, taskActions.setTaskUpdateFetchingFlag(false)),
      dispatch.bind(this, taskActions.setTaskUpdateFetchingFlag(false)),
    ),
  );
};

/**
 * @param {Number} taskId
 */
export const offerTaskAccept = taskId => dispatch => {
  dispatch(taskActions.setTaskUpdateFetchingFlag(true));
  dispatch(taskActions.setTaskUpdateStatus(ACCEPTED));
  dispatch(taskActions.setLastTaskId(taskId));

  dispatch(
    taskCore.actions.offerTaskAccept(
      taskId,
      dispatch.bind(this, taskActions.setTaskUpdateFetchingFlag(false)),
      response => {
        dispatch.bind(this, taskActions.setTaskUpdateFetchingFlag(false));
        dispatch.bind(this, taskActions.setTaskUpdateStatus(null));
        dispatch.bind(this, taskActions.setTaskUpdateError(response));
      },
    ),
  );
};

/**
 * @param {Number} taskId
 */
export const offerTaskDecline = taskId => dispatch => {
  dispatch(taskActions.setTaskUpdateFetchingFlag(true));
  dispatch(taskActions.setTaskUpdateStatus(DECLINED));

  dispatch(
    taskCore.actions.offerTaskDecline(
      taskId,
      dispatch.bind(this, taskActions.setTaskUpdateFetchingFlag(false)),
      response => {
        dispatch.bind(this, taskActions.setTaskUpdateFetchingFlag(false));
        dispatch.bind(this, taskActions.setTaskUpdateStatus(null));
        dispatch.bind(this, taskActions.setTaskUpdateError(response));
      },
    ),
  );
};

export const getTaskOffers = () => dispatch => {
  dispatch(taskActions.setTaskOffersFetchingFlag(true));
  dispatch(
    taskCore.actions.getTaskOffers(
      dispatch.bind(this, taskActions.setTaskOffersFetchingFlag(false)),
      dispatch.bind(this, taskActions.setTaskOffersFetchingFlag(false)),
    ),
  );
};
